import React, { useState } from 'react';
import './LimitExceededModal.css';
import { PaymentModal } from './PaymentModal';

function LimitExceededModal({ onClose, isOpen }) {
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);

  const handleBuyCredits = () => {
    setIsPaymentModalOpen(true);
  };

  const handleClose = () => {
    setIsPaymentModalOpen(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-content">
          <h2>Лимит обработок исчерпан</h2>
          <p>Вы израсходовали все доступные обработки документов.</p>
          <p>Чтобы продолжить, приобретите дополнительные обработки.</p>
          <div className="modal-buttons">
            <button className="modal-button primary" onClick={handleBuyCredits}>
              Купить обработки
            </button>
            <button className="modal-button secondary" onClick={handleClose}>
              Закрыть
            </button>
          </div>
        </div>
      </div>

      <PaymentModal
        isOpen={isPaymentModalOpen}
        onClose={() => {
          setIsPaymentModalOpen(false);
          onClose();
        }}
      />
    </>
  );
}

export default LimitExceededModal; 